import React from 'react';
import { useDispatch } from 'react-redux';
import { API_USER } from 'src/api/user';
import { useAppSelector } from 'src/store';
import { setChildrenGroup, setMainGroup } from 'src/store/apps/userSlice';
import useToast from '../useToast';
import { useTranslation } from 'react-i18next';
import { setGroupActionType } from 'src/store/apps/siteSlice';
import { ENUM_GROUP_ACTION, TEST_MODE } from '../../enums/enums';
import useStateRef from '../useStateRef';
import { setGroupData } from '../../store/apps/userSlice';

export default function useGroupThree({ setChooseGroupeId = undefined } = {}) {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { successToast } = useToast();
  const childrenGroup = useAppSelector((state) => state.user.group.children);
  const groupHash = useAppSelector((state) => state.user.group.hash);
  const mainGroup = useAppSelector((state) => state.user.group.main);
  const childrenRef = useStateRef(childrenGroup);
  const childrenList = Object.values(childrenGroup)?.flat();
  const mainGroupId = String(mainGroup.groupId);

  const getParentId = (needId) => {
    const parentGroupId = groupHash[needId]?.parentId;

    if (parentGroupId) return parentGroupId;

    for (let key in childrenGroup) {
      const curGroup = childrenGroup[key];
      if (curGroup.some((el) => el.groupId == needId)) {
        return key;
      }
    }

    // if (needId == mainGroupId) return;
  };

  const updateMainGroup = async () => {
    await API_USER.group
      .main()
      .then((e) => {
        const data = e.data;
        let newData = [];
        newData = data;

        dispatch(setMainGroup(newData));
        if (newData.length === 1) {
          setChooseGroupeId?.(newData.groupId);
        }
      })
      .catch(console.log);
  };

  const updateChildrenGroup = async (chooseGroupId) => {
    if (!+chooseGroupId) return;
    await API_USER.group
      .children(+chooseGroupId)
      .then((e) => {
        const list = e.data?.list || [];
        const children = { ...childrenRef.current, [chooseGroupId]: list };

        dispatch(setChildrenGroup(children));
      })
      .catch(console.log);
  };

  const updateChildrenGroupList = async (chooseIdList) => {
    const children = { ...childrenGroup };
    for (let i = 0; i < chooseIdList.length; i++) {
      const id = chooseIdList[i];
      if (!+id) continue;

      await API_USER.group
        .children(id)
        .then((e) => {
          const list = e.data?.list || [];
          children[id] = list;
        })
        .catch(console.log);
    }

    dispatch(setChildrenGroup(children));
    return children;
  };

  const updateAsyncChildrenList = async (chooseIdList) => {
    const children = { ...childrenGroup };

    let promises = [];
    chooseIdList.forEach((id) => {
      if (!+id) return;
      const promise = API_USER.group
        .children(+id, [605])
        .then((e) => {
          const list = e.data?.list || [];
          children[id] = list;
        })
        .catch(console.log);
      promises.push(promise);
    });

    await Promise.allSettled(promises);

    dispatch(setChildrenGroup(children));
    return children;
  };

  const onDeleteGroup = async (groupId) => {
    await API_USER.group
      .delete(groupId)
      .then((e) => {
        successToast(t('Successfully deleted'));
        dispatch(setGroupActionType(ENUM_GROUP_ACTION.info));

        const parentId = getParentId(groupId);
        updateChildrenGroup(parentId);
      })
      .catch(console.error);
  };

  const onMoveGroup = (groupId, newId) => {
    if (TEST_MODE) {
      dispatch(setGroupActionType(ENUM_GROUP_ACTION.info));
      return;
    }

    API_USER.group
      .move(groupId, newId)
      .then(async (e) => {
        dispatch(setGroupActionType(ENUM_GROUP_ACTION.info));
        successToast(t('Successfully moved'));
        const parentId = getParentId(groupId);
        updateChildrenGroupList([parentId, newId]);
        setChooseGroupeId?.(parentId);
      })
      .catch(console.error);
  };

  const onRenameGroupe = (groupId, newName) => {
    API_USER.group
      .rename(groupId, newName)
      .then((e) => {
        dispatch(setGroupActionType(ENUM_GROUP_ACTION.info));
        successToast(t('Successfully renamed'));
        const parentId = getParentId(groupId);
        updateChildrenGroup(parentId);
      })
      .catch(console.error);
  };

  const getSelectItems = (chosenGroup, threeStruct = groupHash) => {
    const parentId = getParentId(chosenGroup) || threeStruct[chosenGroup]?.parentId;

    if (parentId == mainGroup.name) return chosenGroup;

    return parentId ? `${parentId}-${chosenGroup}` : `${chosenGroup}`;
  };

  const findParent = async (elemId) => {
    if (!elemId) return;
    if (childrenGroup[elemId]) return;
    if (childrenList.find((el) => el.groupId === elemId)?.game) return;

    await updateChildrenGroup(elemId);
    const parentId = getParentId(elemId);
    if (parentId == mainGroup.name) return;
    if (+parentId) await findParent(parentId);
  };

  const getExpandedItems = (chosenGroup, threeStruct) => {
    const expandedItems = [];

    const fillExpanded = (chosenGroup) => {
      const curExpanded = getSelectItems(chosenGroup, threeStruct);
      expandedItems.push(curExpanded);
      if (String(curExpanded)?.split('-')?.[1]) {
        fillExpanded(curExpanded.split('-')[0]);
      }
    };

    fillExpanded(chosenGroup);

    return expandedItems;
  };

  const updateThree = async ({
    selectGroupId,
    setSelectedItems,
    setExpandedItems,
    threeStruct = groupHash
  }) => {
    if (mainGroupId == selectGroupId) {
      setSelectedItems([String(selectGroupId)]);
      setExpandedItems([String(selectGroupId)]);
      return;
    }

    const parentId = getParentId(selectGroupId) || threeStruct[selectGroupId]?.parentId;

    // если нет родителей и основная группа
    // if (!parentId && mainGroupId == selectGroupId) {

    if (parentId) await findParent(parentId);

    const newSelectedItems = [getSelectItems(selectGroupId, threeStruct)];
    const newExpandedItems = getExpandedItems(selectGroupId, threeStruct);
    setSelectedItems(newSelectedItems);
    setExpandedItems(newExpandedItems);
  };

  const buildThreeById = async (id, threeId = {}, listNewId = [], listOldId = []) => {
    if (!id) return { threeId, listNewId, listOldId };
    if (id == mainGroupId) return { threeId, listNewId, listOldId };

    const parentId = getParentId(id);

    if (parentId) {
      threeId[id] = groupHash[id];
      listOldId.push(id);
      return await buildThreeById(parentId, threeId, listNewId, listOldId);
    }

    const res = await API_USER.group.getData(id);
    listNewId.push(id);
    console.log(res);
    const groupInfo = res.data;
    const parentServerId = groupInfo.parentId;
    dispatch(setGroupData({ id: +id, data: groupInfo }));
    threeId[id] = groupInfo;
    if (parentServerId) {
      return await buildThreeById(parentServerId, threeId, listNewId, listOldId);
    }
    return { threeId, listNewId, listOldId };
  };

  return {
    updateMainGroup,
    updateChildrenGroup,
    updateChildrenGroupList,
    updateAsyncChildrenList,
    getParentId,
    getSelectItems,
    onDeleteGroup,
    onMoveGroup,
    findParent,
    updateThree,
    getExpandedItems,
    buildThreeById,
    onRenameGroupe
  };
}
